import request from '@/axios';

export const getUsualList = (query) => {
  return request({
    url: '/lebo-log/usual/list',
    method: 'get',
    params: query
  })
}

export const getApiList = (query) => {
  return request({
    url: '/lebo-log/api/list',
    method: 'get',
    params: query
  })
}

export const getErrorList = (query) => {
  return request({
    url: '/lebo-log/error/list',
    method: 'get',
    params: query
  })
}


export const getUsualLogs = (id) => {
  return request({
    url: '/lebo-log/usual/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
export const getApiLogs = (id) => {
  return request({
    url: '/lebo-log/api/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
export const getErrorLogs = (id) => {
  return request({
    url: '/lebo-log/error/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
/**
 * 查询审批日志
 * @param { bizCode: 业务code, bizRefrenceId: 数据ID} query 
 */
export const getApproveLogs = (query) => {
  return request({
    url: '/lebo-desk/review-biz/list-examine',
    method: 'GET',
    params: query
  })
}
